import { createContext } from 'react'

const ApplicationContext = createContext<any>({})


export default ApplicationContext